{
	"name": "umbrella",
	"version": "1.5.0",
	"type": "module",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"lint": "ng lint",
		"build": "ng build",
		"setBuildNumber": "node ./set-build-number.js",
		"intellij": "ng serve --host=0.0.0.0 --poll=2000 --port=4201",
		"postinstall": "patch-package"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^21.2.11",
		"@angular/cdk": "^21.2.9",
		"@angular/common": "^21.2.11",
		"@angular/compiler": "^21.2.11",
		"@angular/core": "^21.2.11",
		"@angular/forms": "^21.2.11",
		"@angular/localize": "^21.2.11",
		"@angular/platform-browser": "^21.2.11",
		"@angular/platform-browser-dynamic": "^21.2.11",
		"@angular/router": "^21.2.11",
		"@nebular/eva-icons": "^17.0.0",
		"@nebular/moment": "^17.0.0",
		"@nebular/theme": "^17.0.0",
		"@ng-bootstrap/ng-bootstrap": "^20.0.0",
		"@ng-select/ng-select": "^21.8.1",
		"@ngrx/effects": "^21.1.0",
		"@ngrx/store": "^21.1.0",
		"@ngrx/store-devtools": "^21.1.0",
		"@ngx-translate/core": "^17.0.0",
		"@ngx-translate/http-loader": "^17.0.0",
		"angular-svg-icon": "^18.0.2",
		"bootstrap": "^5.3.0",
		"eva-icons": "1.1.3",
		"file-saver": "^2.0.2",
		"immutable": "^5.0.3",
		"lodash": "^4.17.21",
		"moment": "^2.30.1",
		"ngx-filesaver": "^21.0.0",
		"ngx-pagination": "^6.0.3",
		"nodep-date-input-polyfill": "^5.2.0",
		"readline": "^1.3.0",
		"rxjs": "^7.4.0",
		"ts-md5": "^2.0.1",
		"tslib": "^2.8.1",
		"zone.js": "^0.15.1"
	},
	"devDependencies": {
		"@angular-eslint/builder": "^21.3.1",
		"@angular-eslint/eslint-plugin": "^21.3.1",
		"@angular-eslint/eslint-plugin-template": "^21.3.1",
		"@angular-eslint/schematics": "^21.3.1",
		"@angular-eslint/template-parser": "^21.3.1",
		"@angular/build": "^21.2.27",
		"@angular/cli": "^21.2.9",
		"@angular/compiler-cli": "^21.2.11",
		"@angular/language-service": "^21.2.11",
		"@ngrx/schematics": "^21.1.0",
		"@types/lodash": "^4.17.13",
		"@types/node": "^22.9.1",
		"@typescript-eslint/eslint-plugin": "^8.15.0",
		"@typescript-eslint/parser": "^8.15.0",
		"eslint": "^9.15.0",
		"patch-package": "^8.0.1",
		"replace-in-file": "^8.2.0",
		"ts-node": "^10.9.2",
		"typescript": "^5.9.3"
	}
}
